<p-toast />
<p-confirmPopup />
<div class="layout-topbar" style="background-color: #DA291C;">
    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars menu-icon"></i>
    </button>

    <a style="margin-left: 15px;" class="layout-topbar-logo" routerLink="/dashboard">
        <img src="assets/layout/images/{{layoutService.config().colorScheme === 'light' ? 'logoClaro' : 'logoClaro'}}.png" alt="logo">
        <span style="color: white; font-size: 1.7rem; padding-top: 17px;">Parqueos</span>
    </a>


    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">

        <p-button label="{{this.user}}" icon="pi pi-user" severity="danger" class="mr-3" />
     
        <p-button label="{{this.rol}}"  icon="pi pi-list" severity="danger" class="mr-3" />

        <p-button label="Cerrar Sesión" severity="danger" (onClick)="confirmLogout($event)" icon="pi pi-sign-out"  />
    </div>

</div>
